module.exports = __webpack_public_path__ + "our_artists.png?f0ab096cd4ea34ef328afd98bdab3114";


//////////////////
// WEBPACK FOOTER
// ./src/static/headers/our_artists.png
// module id = 189
// module chunks = 0